import React from 'react';
import s from '../../MyOrders/MyOrdersPopups/InfoCheckBox/InfoCheckbox.module.css';

type Props = {
	labelTxt: string;
	id: string;
	check: boolean;
	onChangeFn: () => void;
};
const AskQuestionCheckBox: React.FC<Props> = ({
	labelTxt,
	id,
	check,
	onChangeFn,
}) => {
	return (
		<div className={s.checkBoxContainer}>
			<input
				className={s.checkboxInput}
				onChange={onChangeFn}
				id={id}
				disabled={false}
				checked={check}
				type={'checkbox'}
			/>
			<label htmlFor={id}>{labelTxt}</label>
		</div>
	);
};
//key={`answer2${id}${labelTxt}`}
export default AskQuestionCheckBox;
